//app/components/thailand-tapioca-starch-manufacturing-export-services-fcl-lcl/Hero.tsx
"use client";
import * as React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import { useTranslations } from "next-intl";

export default function Hero() {
  const t = useTranslations("OurServices");
  return (
    <Box className="our-services-hero">
        <Container className="container">
          <Grid container>
            <Grid size={12}>
              <Typography variant="h1" data-aos="zoom-in" sx={{ whiteSpace: {xs: 'normal', lg: "pre-line"} }}>
                {t("Hero.title")}
              </Typography>
            </Grid>
          </Grid>
        </Container>
    </Box>
  );
}
